import React, { useState } from 'react'
import { Button } from 'primereact/button'
import { Message } from 'primereact/message'
import { Divider } from 'primereact/divider'
import { Toast } from 'primereact/toast'
import { OrderSummaryKPIs } from './OrderSummaryKPIs'
import { OrderCard } from './OrderCard'
import { useLineItems } from '../../../hooks/useLineItems'
import { ViewOrderInfoDialog } from './../ViewOrderInfoDialog'
import { ShippingOrder } from '../../../DeShippingTableWrapper'
import { useOrderSelection } from '../../../hooks/useOrderSelection'
import { useLineItemSelection } from '../../../hooks/useLineItemSelection'

interface OrderProcessingInitialViewProps {
  orderSelection: ReturnType<typeof useOrderSelection>
  lineItemsHook: ReturnType<typeof useLineItems>
  lineItemSelection: ReturnType<typeof useLineItemSelection>
  onProcessOrders: () => void
  onCloseDialog: () => void
}

export const OrderProcessingInitialView: React.FC<OrderProcessingInitialViewProps> = ({
  orderSelection,
  lineItemsHook,
  lineItemSelection,
  onProcessOrders,
  onCloseDialog
}) => {
  const [isOrderDialogVisible, setIsOrderDialogVisible] = useState(false)

  // Handler for viewing order details when card is clicked
  const handleOrderCardClick = (order: ShippingOrder) => {
    orderSelection.selectOrder(order)
    setIsOrderDialogVisible(true)
  }

  return (
    <div>
      {/* Summary Cards Section */}
      <OrderSummaryKPIs selectedOrders={orderSelection.getSelectedOrdersData()} />

      <Divider />

      {/* Orders List Section */}
      <div className="mb-4">
        <h6 className="mb-3 flex align-items-center gap-2">
          <i className="pi pi-list text-primary" style={{ fontSize: '1.1rem', marginRight: '8px' }}></i>
          Orders to Process
        </h6>
        
        <div className="orders-container">
          {orderSelection.getSelectedOrdersData().map((order) => (
            <OrderCard 
              key={order.order_id} 
              order={order} 
              onOrderClick={handleOrderCardClick}
            />
          ))}
        </div>
      </div>

      {/* Info Message */}
      <Message
        severity="info"
        content={
          <div className="flex align-items-center gap-2">
            <i className="pi pi-info-circle" style={{ marginRight: '0.5rem' }}></i>
            <span>
              The system will analyze each order and determine the optimal fulfillment strategy across available locations.
              Click on any order card to view detailed information.
            </span>
          </div>
        }
        className="mb-4"
      />

      <Divider />

      {/* Action Buttons */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginRight: '2px', width: '100%' }}>
        <Button
          label="Cancel"
          icon="pi pi-times"
          severity="danger"
          onClick={onCloseDialog}
          className="p-button-outlined"
        />
        <Button
          label="Process Orders"
          icon="pi pi-cog"
          onClick={onProcessOrders}
          className="p-button-primary"
        />
      </div>

      {/* ViewOrderInfoDialog */}
      <ViewOrderInfoDialog
        orderSelection={orderSelection}
        lineItemsHook={lineItemsHook}
        lineItemSelection={lineItemSelection}
        visible={isOrderDialogVisible}
        onHide={() => setIsOrderDialogVisible(false)}
      />
    </div>
  )
} 